import { render, staticRenderFns } from "./EditSquareIcon.vue?vue&type=template&id=5e46b33f&scoped=true"
import script from "./EditSquareIcon.vue?vue&type=script&lang=js"
export * from "./EditSquareIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e46b33f",
  null
  
)

export default component.exports